import { ButtonBack, ButtonNext } from 'pure-react-carousel';

import { ArrowIconWithBackground } from './ArrowIconWithBackground';

const NavigationArrows = () => {
  return (
    <>
      <ButtonBack className="absolute inset-y-0 left-2">
        <ArrowIconWithBackground />
      </ButtonBack>

      <ButtonNext className="absolute inset-y-0 right-2">
        <div className="rotate-180">
          <ArrowIconWithBackground />
        </div>
      </ButtonNext>
    </>
  );
};

export default NavigationArrows;
